import React, { useRef } from 'react';
import { motion, useReducedMotion, useScroll, useTransform } from 'framer-motion';
import { ArrowRightIcon, GiftIcon, QrCodeIcon, StarIcon } from 'lucide-react';
import { appSteps, images } from '../data/site';
const EASE = [0.23, 1, 0.32, 1] as const;
const ICONS = [GiftIcon, QrCodeIcon, StarIcon];
export function LoyaltyApp() {
  const ref = useRef<HTMLElement | null>(null);
  const reduce = useReducedMotion();
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const yBack = useTransform(scrollYProgress, [0, 1], reduce ? ['0%', '0%'] : ['8%', '-8%']);
  const yFront = useTransform(scrollYProgress, [0, 1], reduce ? ['0%', '0%'] : ['-5%', '10%']);
  return <section id="app" ref={ref} className="bg-espresso text-cream" data-id="element-56" data-mp="3totqw8db3vtg">
      <div className="mx-auto grid max-w-7xl items-center gap-10 px-6 pt-20 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.05fr)] lg:gap-16 lg:pt-24" data-id="element-57" data-mp="1ud0q00nee6bg">
        <div className="pb-4 lg:pb-24" data-id="element-58" data-mp="1zcdmze7zgtrr">
          <p className="text-sm text-clay" data-id="element-59" data-mp="3627vjace1ok5">Aden's App · gratis</p>
          <h2 className="mt-5 text-[clamp(2.25rem,5vw,4rem)] font-semibold leading-[1.02] tracking-[-0.03em]" data-id="element-60" data-mp="363ixr5q6qo95">
            Spaar bij elk bezoek
          </h2>
          <p className="mt-6 max-w-lg text-lg leading-relaxed text-cream/70" data-id="element-61" data-mp="2wbmyvsg9yu3v">
            Je digitale spaarkaart met welkomstcadeau, punten en exclusieve drops. Registreer je en
            je eerste koffie is van ons.
          </p>

          <ol className="mt-12 space-y-8" data-id="element-62" data-mp="3p0k6n1mv18id">
            {appSteps.map((step, i) => {
            const Icon = ICONS[i];
            return <motion.li key={step.index} initial={{
              opacity: 0,
              y: 12
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-15%'
            }} transition={{
              duration: 0.25,
              ease: EASE,
              delay: i * 0.06
            }} className="flex gap-5" data-id="element-63" data-mp="3g05izvmfbhbp" data-mpi={i}>
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-cream/10 text-clay" data-id="element-64" data-mp="1zo8jzzq9r57y">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-65" data-mp="262e1lfnnzmcz" />
                  </span>
                  <div data-id="element-66" data-mp="2601ll81gvm2k">
                    <h3 className="text-lg font-medium" data-id="element-67" data-mp="1s3636ozbsi9u">
                      <span className="mr-3 text-sm text-cream/40" data-id="element-68" data-mp="1s4pjugow8vc5">{step.index}</span>
                      {step.title}
                    </h3>
                    <p className="mt-2 max-w-md text-base leading-relaxed text-cream/60" data-id="element-69" data-mp="1icbi3nxtfopz">
                      {step.body}
                    </p>
                  </div>
                </motion.li>;
          })}
          </ol>

          <div className="mt-12 flex flex-wrap items-center gap-4" data-id="element-70" data-mp="18ggra5jfunc4">
            <a href="#app" className="group inline-flex items-center gap-2.5 rounded-full bg-cream px-8 py-4 text-sm font-medium text-ink transition-colors duration-150 ease-out hover:bg-clay hover:text-cream" data-id="element-71" data-mp="1des14g9qgxuc">
              Download de app
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" data-id="element-72" data-mp="kqqosbvmaz6a" />
            </a>
            <span className="text-sm text-cream/50" data-id="element-73" data-mp="ftqiq0yrpwf6">iOS &amp; Android · gratis</span>
          </div>
        </div>

        <div className="relative mx-auto h-[460px] w-full max-w-xl sm:h-[600px] lg:h-[720px]" data-id="element-74" data-mp="tt9m6ggmwjl5">
          <div className="absolute inset-x-6 bottom-0 top-16 rounded-t-[999px] bg-clay/25" aria-hidden="true" data-id="element-75" data-mp="pp1y8li037nz" />
          <motion.img style={{
          y: yBack
        }} src={images.phoneReward} alt="Aden's app: welkomstcadeau verzilveren" className="absolute bottom-0 left-0 w-[54%] drop-shadow-2xl sm:left-2" data-id="element-76" data-mp="yrjkgzxno0az" />
          <motion.img style={{
          y: yFront
        }} src={images.phoneHome} alt="Aden's app: spaarkaart met punten en beloningen" className="absolute right-0 top-4 w-[64%] drop-shadow-2xl sm:right-2" data-id="element-77" data-mp="18hcsxs2i3zb0" />
        </div>
      </div>
    </section>;
}